import React, { useState, useEffect, useRef } from "react";
import { withNamespaces } from "react-i18next";
import "rc-time-picker/assets/index.css";
import Checkbox from "@material-ui/core/Checkbox";

const WeekDayCheckboxes = (props) => {
    const [selectedWeekdays, setSelectedWeekdays] = useState(props.selectedWeekdays ?? []);
    const setWeekdaysForParent = props.setWeekdays;

    const weekDaysNumber = [1, 2, 3, 4, 5, 6, 0];
    const weekDaysText = [
        props.t("allgemein.tageKurz.Monday"),
        props.t("allgemein.tageKurz.Tuesday"),
        props.t("allgemein.tageKurz.Wednesday"),
        props.t("allgemein.tageKurz.Thursday"),
        props.t("allgemein.tageKurz.Friday"),
        props.t("allgemein.tageKurz.Saturday"),
        props.t("allgemein.tageKurz.Sunday"),
    ];

    function setSelected(weekdays) {
        setSelectedWeekdays(weekdays);
        setWeekdaysForParent(weekdays);

        console.debug("new selectedWeekdays %o", weekdays);
    }

    return (
        <div className="flex-iac">
            {weekDaysNumber.map((value, index) => {
                return (
                    <div className="flex-iac">
                        {weekDaysText[index]}
                        <Checkbox
                            color="primary"
                            size="small"
                            style={{ padding: "5px", paddingRight: "10px" }}
                            value={value}
                            onChange={(e) => {
                                console.debug("CheckBox changed Checked: %o; Value: %o; selectedWeekdays (old): %o", e.target.checked, value, selectedWeekdays);

                                if (e.target.checked == true) {
                                    setSelected([...selectedWeekdays, parseInt(e.target.value)]);
                                }
                                else {
                                    setSelected(selectedWeekdays.filter((w) => w !== value));
                                }
                            }}
                            checked={selectedWeekdays.includes(value)}
                        />
                    </div>
                )
            })}
            <div className="flex-iac">
                <button
                    type="button"
                    id=""
                    style={{
                        width: "auto",
                        marginRight: "2px",
                        color: "blue",
                        border: "none",
                        backgroundColor: "white",
                    }}
                    onClick={() => { setSelected(weekDaysNumber); }}
                >
                    {props.t("allgemein.alle")}
                </button>
                |
                <button
                    type="button"
                    id=""
                    style={{
                        width: "auto",
                        marginLeft: "2px",
                        color: "blue",
                        border: "none",
                        backgroundColor: "white",
                    }}
                    onClick={() => { setSelected([]); }}
                >
                    {props.t("allgemein.keine")}
                </button>
            </div>

        </div>
    );
};

export default withNamespaces()(WeekDayCheckboxes);
